<template>
  <div
    :content="
      status != 'RUNNING' && !error
        ? 'Investimento parado'
        : error && status != 'RUNNING'
        ? 'Error, verifique o parâmetro abaixo'
        : 'Investimento em execução'
    "
    v-tippy="{
      arrow: true,
      theme: error && status != 'RUNNING' ? 'red' : 'green',
    }"
    class="relative flex w-3 items-center justify-center"
  >
    <span
      v-show="status == 'RUNNING'"
      class="bg-ontick-green-600 h-3 w-3 rounded-full"
      :class="{
        'animate-ping': position !== 'Zerado',
      }"
    ></span>
    <span
      class="absolute h-3 w-3 rounded-full"
      :class="status === 'RUNNING' ? 'bg-ontick-green-600 ' : ' bg-gray-500 '"
    ></span>
    <!-- <span :class="[activitySign, 'activity_sign']"></span> -->
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
